const setRecentlyViewedProducts = () => {
    const recentlyViewedContainer = document.querySelector(".js-recently-viewed");

    const productData = {
        productId: recentlyViewedContainer.getAttribute("data-product-id"),
        productTitle: recentlyViewedContainer.getAttribute("data-product-title"),
        productPrice: recentlyViewedContainer.getAttribute("data-product-price"),
        productImg: recentlyViewedContainer.getAttribute("data-product-img"),
        productUrl: recentlyViewedContainer.getAttribute("data-product-url"),
        productViewTimeStamp: Date.now(),
    };

    if (productData.productId) {
        const productList = [];
        let jsonResp, jsonRespArr, jsonRespArrStr;
        const numberOfProducts = 16;
        productList.push(productData);
        const currProductPageTitle = productData.productTitle;
        const productDataString = JSON.stringify(productList);
        const localData = localStorage.getItem("recentlyViewedProducts");

        if (localData === null) {
            localStorage.setItem("recentlyViewedProducts", productDataString);
        } else if (localData) {
            const oldProductData = localStorage.getItem("recentlyViewedProducts");
            const countProductData = (oldProductData.match(/productTitle/g) || []).length;
            const sameProduct = oldProductData.includes(currProductPageTitle);
            if (countProductData <= numberOfProducts && sameProduct == false) {
                jsonResp = JSON.parse(oldProductData);
                jsonRespArr = jsonResp.concat(productList);
                jsonRespArrStr = JSON.stringify(jsonRespArr);
                localStorage.setItem("recentlyViewedProducts", jsonRespArrStr);
            } else if (countProductData >= numberOfProducts && sameProduct == false) {
                jsonResp = JSON.parse(oldProductData);
                jsonResp.shift();
                jsonRespArr = jsonResp.concat(productList);
                jsonRespArr = JSON.stringify(jsonRespArr);
                localStorage.setItem("recentlyViewedProducts", jsonRespArr);
            }
        }
    }
};

setRecentlyViewedProducts();
